import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: () => import('@/layout/index.vue'),
    redirect: '/dashboard',
    children: [
      { path: 'dashboard', name: 'Dashboard', component: () => import('@/views/dashboard/index.vue'), meta: { title: '仪表盘', icon: 'el-icon-s-home' } },
      // 用户管理
      { path: 'user', name: 'UserManage', component: () => import('@/views/user/index.vue'), meta: { title: '用户管理', icon: 'el-icon-user' } },
      // 充值管理
      { path: 'recharge', name: 'RechargeManage', component: () => import('@/views/recharge/index.vue'), meta: { title: '充值管理', icon: 'el-icon-money' } },
      // 文章管理
      { path: 'article', name: 'ArticleManage', component: () => import('@/views/article/index.vue'), meta: { title: '文章管理', icon: 'el-icon-document' } },
      { path: 'article/edit/:id?', name: 'ArticleEdit', component: () => import('@/views/article/edit.vue'), meta: { title: '编辑文章' } },
      { path: 'article-category', name: 'ArticleCategory', component: () => import('@/views/article/category.vue'), meta: { title: '分类管理' } },
      // 短信服务
      { path: 'service', name: 'ServiceManage', component: () => import('@/views/service/index.vue'), meta: { title: '服务管理', icon: 'el-icon-message' } },
      // 号码管理
      { path: 'number', name: 'NumberManage', component: () => import('@/views/number/index.vue'), meta: { title: '号码管理', icon: 'el-icon-phone' } },
      // 反馈管理
      { path: 'feedback', name: 'FeedbackManage', component: () => import('@/views/feedback/index.vue'), meta: { title: '反馈管理', icon: 'el-icon-chat-line-round' } },
      // 客服管理
      { path: 'chat', name: 'ChatManage', component: () => import('@/views/chat/index.vue'), meta: { title: '客服管理', icon: 'el-icon-service' } },
      { path: 'chat/detail/:id?', name: 'ChatDetail', component: () => import('@/views/chat/detail.vue'), meta: { title: '会话详情' } },
      // 彩票管理
      { path: 'lottery/type', name: 'LotteryType', component: () => import('@/views/lottery/type.vue'), meta: { title: '彩种管理', icon: 'el-icon-trophy' } },
      { path: 'lottery/result', name: 'LotteryResult', component: () => import('@/views/lottery/result.vue'), meta: { title: '开奖记录' } },
      { path: 'lottery/bet', name: 'LotteryBet', component: () => import('@/views/lottery/bet.vue'), meta: { title: '投注记录' } },
      // eSIM管理
      { path: 'esim', name: 'EsimManage', component: () => import('@/views/esim/index.vue'), meta: { title: 'eSIM管理', icon: 'el-icon-connection' } },
      // 操作日志
      { path: 'log', name: 'LogManage', component: () => import('@/views/log/index.vue'), meta: { title: '操作日志', icon: 'el-icon-notebook-2' } },
      // 系统设置
      { path: 'settings', name: 'Settings', component: () => import('@/views/settings/index.vue'), meta: { title: '系统设置', icon: 'el-icon-setting' } },
      // Telegram Bot 管理
      { path: 'telegram', name: 'TelegramManage', component: () => import('@/views/telegram/index.vue'), meta: { title: 'Telegram管理', icon: 'el-icon-chat-dot-round' } }
    ]
  }
]

const router = new VueRouter({
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  document.title = (to.meta.title || '') + ' - SMS-Man 管理后台'
  const token = store.state.token
  if (to.path === '/login') {
    next()
  } else if (!token) {
    next('/login')
  } else {
    next()
  }
})

export default router
